import { getFunnelCache } from '../../../lib/funnels/functions/v1/default/getFunnelCache.js'
import { updateSession } from '../../../lib/funnels/functions/v1/default/updateSession.js'
import { getLoc } from '../../../lib/funnels/functions/v1/middleware/getLoc.js'
import { stripPhone } from '../../../lib/funnels/functions/v1/default/stripPhone.js'
import { queryParamsToSession } from '../../../lib/funnels/functions/v1/default/queryParamsToSession.js'
import { updateInput } from '../../../lib/funnels/functions/v1/html/updateInput.js'
import { hideFormInput } from '../../../lib/funnels/functions/v1/html/hideFormInput.js'
import { STATES } from '../../../lib/funnels/constants/states.js'

const SESSION_ID = 'dsaFunnel'

document.addEventListener('DOMContentLoaded', async () => {
  queryParamsToSession(SESSION_ID)
  updateSession(SESSION_ID, 'engaged', '1')

  const sessData = getFunnelCache(SESSION_ID) || {}

  const nameInput = document.querySelector('input[name="Name"]')
  const emailInput = document.querySelector('input[name="Email"]')
  const phoneInput = document.querySelector('input[name="Phone"]')
  const stateInput = document.querySelector('select[name="state"]')

  if (nameInput) {
    updateInput(
      nameInput,
      sessData?.first
        ? `${sessData.first} ${sessData.last || ''}`
        : sessData?.name || '',
    )
  }
  if (emailInput) updateInput(emailInput, sessData?.email || '')
  if (phoneInput) updateInput(phoneInput, sessData?.phone || '')

  if (stateInput && stateInput instanceof HTMLSelectElement) {
    STATES.forEach((state) => {
      const opt = document.createElement('option')
      opt.value = state.abbreviation
      opt.textContent = state.name
      stateInput.appendChild(opt)
    })
  }

  try {
    const loc = await getLoc()
    if (loc.region) {
      updateSession(SESSION_ID, 'region', loc.region)
      updateSession(SESSION_ID, 'ip', loc.remoteAddress || '')
      if (stateInput) {
        updateInput(stateInput, loc.region)
        hideFormInput(stateInput)
      }
    }
  } catch (err) {
    console.error('getLoc failed', err)
  }

  /**
   * Convenience: read the whole session object (alias for getFunnelCache).
   * @param {string} value
   * @returns ''
   */
  function formatPhone(value) {
    const digits = value.replace(/\D/g, '').slice(0, 10)
    const part1 = digits.slice(0, 3)
    const part2 = digits.slice(3, 6)
    const part3 = digits.slice(6, 10)
    if (digits.length > 6) return `(${part1}) ${part2}-${part3}`
    if (digits.length > 3) return `(${part1}) ${part2}`
    if (digits.length > 0) return `(${part1}`
    return ''
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', (e) => {
      const target = /** @type {HTMLInputElement} */ (e.target)
      const formatted = formatPhone(target.value)
      target.value = formatted
      const isValid = /^\(\d{3}\) \d{3}-\d{4}$/.test(formatted)
      target.setCustomValidity(isValid ? '' : 'Phone number is required.')
    })
  }

  const form = /** @type {HTMLFormElement | null} */ (
    document.getElementById('form')
  )

  form?.addEventListener('submit', (e) => {
    e.preventDefault()
    const target = /** @type {HTMLFormElement} */ (e.target)

    const name = /** @type {HTMLInputElement} */ (
      target.elements.namedItem('Name')
    ).value
    const email = /** @type {HTMLInputElement} */ (
      target.elements.namedItem('Email')
    ).value
    const phone = /** @type {HTMLInputElement} */ (
      target.elements.namedItem('Phone')
    ).value
    const trustedFormInput = /** @type {HTMLInputElement | null} */ (
      target.elements.namedItem('xxTrustedFormCertUrl')
    )
    const trustedFormUrl = trustedFormInput?.value || ''

    if (!name || !email || !phone || !trustedFormUrl) return

    const stateEl = /** @type {HTMLSelectElement | null} */ (
      target.elements.namedItem('state')
    )
    const stateValue = stateEl?.value || ''

    updateSession(SESSION_ID, 'name', name)
    updateSession(SESSION_ID, 'email', email)
    updateSession(SESSION_ID, 'phone', phone)
    updateSession(SESSION_ID, 'xxTrustedFormCertUrl', trustedFormUrl)
    if (stateValue) updateSession(SESSION_ID, 'state', stateValue)

    const freshData = getFunnelCache(SESSION_ID) || {}

    const data = {
      DebtOwed: freshData.debtOwed || '',
      email,
      Name: name,
      Phone: stripPhone(phone),
      state: stateValue || freshData.region || freshData.state || '',
      sub1: freshData.sub1 || '',
      sub2: freshData.sub2 || '',
      sub3: freshData.sub3 || '',
      sub4: freshData.sub4 || '',
      sub5: freshData.sub5 || '',
      trid: freshData.trid || '',
      oid: freshData.oid || '',
      utm_campaign: freshData.utm_campaign || '',
      xxTrustedFormCertUrl: trustedFormUrl,
      website: 'debtsolutionamerica.com',
      funnel: 'dsa',
    }

    const params = new URLSearchParams(data).toString()
    window.location.href = `https://funnels.turbodebt.com/my-results/?${params}`
  })
})
